import { inject, Pipe, PipeTransform } from '@angular/core';
import { Frequency as GalaxyFrequency } from '@vendasta/galaxy/frequency';
import { BillingTerm } from '../item-pricing-table.interface';
import { FormatBillingPeriodPipe } from '../../common/pipes/billing-period.pipe';
import { galaxyFrequencyToRevenuePeriod } from '../../billing-term-dialog/sales-to-galaxy-frequency.pipe';

@Pipe({ name: 'formatBillingTerm' })
export class FormatBillingTermPipe implements PipeTransform {
  private formatBillingPeriodPipe = inject(FormatBillingPeriodPipe);

  transform(billingTerm: BillingTerm, frequency?: GalaxyFrequency): string {
    if (!frequency) {
      return this.formatBillingPeriodPipe.transform(billingTerm);
    }

    const revenuePeriod = galaxyFrequencyToRevenuePeriod(frequency);

    return this.formatBillingPeriodPipe.transform(billingTerm, revenuePeriod);
  }
}
